import React from 'react'
import Img from 'gatsby-image/withIEPolyfill'
import { ContainerLg } from '../../GlobalStylesNew'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'
import { prop } from 'ramda'

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0;
  margin-bottom: 20px;
  border-bottom: 1px solid #e6ecf1;
  padding: 50px 0 50px;
  margin-bottom: 50px;
  .gatsby-image-wrapper + .gatsby-image-wrapper {
    margin-left: 10px;
  }
  @media screen and (min-width: 768px) {
    padding: 60px 0 50px;
    margin-bottom: 50px;
    .gatsby-image-wrapper + .gatsby-image-wrapper {
      margin-left: 20px;
    }
  }
`

const Logos = props => (
  <StaticQuery
    query={graphql`
      query {
        lpga: file(relativePath: { eq: "Home/logos/logo_lpga.png" }) {
          childImageSharp {
            fixed(width: 96, height: 70) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        olympics: file(relativePath: { eq: "Home/logos/logo_olympics.png" }) {
          childImageSharp {
            fixed(width: 100, height: 70) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        masters: file(relativePath: { eq: "Home/logos/logo_masters.png" }) {
          childImageSharp {
            fixed(width: 100, height: 70) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usga: file(relativePath: { eq: "Home/logos/logo_usga.png" }) {
          childImageSharp {
            fixed(width: 100, height: 70) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        pgatour: file(relativePath: { eq: "Home/logos/logo_pgatour.png" }) {
          childImageSharp {
            fixed(width: 100, height: 70) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        usagolf: file(relativePath: { eq: "Home/logos/logo_usagolf.png" }) {
          childImageSharp {
            fixed(width: 180, height: 70) {
              ...GatsbyImageSharpFixed
            }
          }
        }
        pga: file(relativePath: { eq: "Home/logos/logo_pga.png" }) {
          childImageSharp {
            fixed(width: 101, height: 95) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    `}
    render={data => (
      <ContainerLg>
        <ImageContainer>
          {prop('lpga', data) ? (
            <Img fixed={data.lpga.childImageSharp.fixed} objectFit="contain" />
          ) : null}
          {prop('olympics', data) ? (
            <Img
              fixed={data.olympics.childImageSharp.fixed}
              objectFit="contain"
            />
          ) : null}
          {prop('masters', data) ? (
            <Img
              fixed={data.masters.childImageSharp.fixed}
              objectFit="contain"
            />
          ) : null}
          {prop('usga', data) ? (
            <Img fixed={data.usga.childImageSharp.fixed} objectFit="contain" />
          ) : null}
          {prop('pgatour', data) ? (
            <Img
              fixed={data.pgatour.childImageSharp.fixed}
              objectFit="contain"
            />
          ) : null}
          {prop('usagolf', data) ? (
            <Img
              fixed={data.usagolf.childImageSharp.fixed}
              objectFit="contain"
            />
          ) : null}
          {prop('pga', data) ? (
            <Img fixed={data.pga.childImageSharp.fixed} objectFit="contain" />
          ) : null}
        </ImageContainer>
      </ContainerLg>
    )}
  />
)

export default Logos
